/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseDeliveryMethodDto } from '../models/api-response-delivery-method-dto';
import { ApiResponseListDeliveryMethodDto } from '../models/api-response-list-delivery-method-dto';
import { createDeliveryMethod } from '../fn/delivery-method-api/create-delivery-method';
import { CreateDeliveryMethod$Params } from '../fn/delivery-method-api/create-delivery-method';
import { deleteDeliveryMethod } from '../fn/delivery-method-api/delete-delivery-method';
import { DeleteDeliveryMethod$Params } from '../fn/delivery-method-api/delete-delivery-method';
import { getAvailableDeliveryMethods } from '../fn/delivery-method-api/get-available-delivery-methods';
import { GetAvailableDeliveryMethods$Params } from '../fn/delivery-method-api/get-available-delivery-methods';
import { getDeliveryMethodByReference } from '../fn/delivery-method-api/get-delivery-method-by-reference';
import { GetDeliveryMethodByReference$Params } from '../fn/delivery-method-api/get-delivery-method-by-reference';
import { updateDeliveryMethod } from '../fn/delivery-method-api/update-delivery-method';
import { UpdateDeliveryMethod$Params } from '../fn/delivery-method-api/update-delivery-method';

@Injectable({ providedIn: 'root' })
export class DeliveryMethodApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDeliveryMethodByReference()` */
  static readonly GetDeliveryMethodByReferencePath = '/v1/api/delivery-methods/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveryMethodByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryMethodByReference$Response(params: GetDeliveryMethodByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDeliveryMethodDto>> {
    return getDeliveryMethodByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveryMethodByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryMethodByReference(params: GetDeliveryMethodByReference$Params, context?: HttpContext): Observable<ApiResponseDeliveryMethodDto> {
    return this.getDeliveryMethodByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDeliveryMethodDto>): ApiResponseDeliveryMethodDto => r.body)
    );
  }

  /** Path part for operation `updateDeliveryMethod()` */
  static readonly UpdateDeliveryMethodPath = '/v1/api/delivery-methods/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDeliveryMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDeliveryMethod$Response(params: UpdateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDeliveryMethodDto>> {
    return updateDeliveryMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDeliveryMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDeliveryMethod(params: UpdateDeliveryMethod$Params, context?: HttpContext): Observable<ApiResponseDeliveryMethodDto> {
    return this.updateDeliveryMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDeliveryMethodDto>): ApiResponseDeliveryMethodDto => r.body)
    );
  }

  /** Path part for operation `deleteDeliveryMethod()` */
  static readonly DeleteDeliveryMethodPath = '/v1/api/delivery-methods/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDeliveryMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDeliveryMethod$Response(params: DeleteDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteDeliveryMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDeliveryMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDeliveryMethod(params: DeleteDeliveryMethod$Params, context?: HttpContext): Observable<void> {
    return this.deleteDeliveryMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createDeliveryMethod()` */
  static readonly CreateDeliveryMethodPath = '/v1/api/delivery-methods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDeliveryMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeliveryMethod$Response(params: CreateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDeliveryMethodDto>> {
    return createDeliveryMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDeliveryMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeliveryMethod(params: CreateDeliveryMethod$Params, context?: HttpContext): Observable<ApiResponseDeliveryMethodDto> {
    return this.createDeliveryMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDeliveryMethodDto>): ApiResponseDeliveryMethodDto => r.body)
    );
  }

  /** Path part for operation `getAvailableDeliveryMethods()` */
  static readonly GetAvailableDeliveryMethodsPath = '/v1/api/delivery-methods/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableDeliveryMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDeliveryMethods$Response(params: GetAvailableDeliveryMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDeliveryMethodDto>> {
    return getAvailableDeliveryMethods(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailableDeliveryMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDeliveryMethods(params: GetAvailableDeliveryMethods$Params, context?: HttpContext): Observable<ApiResponseListDeliveryMethodDto> {
    return this.getAvailableDeliveryMethods$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListDeliveryMethodDto>): ApiResponseListDeliveryMethodDto => r.body)
    );
  }

}
